module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//7.jpg?f0596cee8dde6c1b4b0db30c24c72c1c";